import { useQuery } from '@tanstack/react-query';
import { useReviewPreviewPageStatus, useReviewPreviewParams } from 'screens/performanceReview/hooks/reviewPreviewHooks';

import { VISIBLE_PROVIDER_TYPES_COLOR_MAPPING } from 'constants/ProjectConstants';
import { getColorFromKey } from 'constants/helper';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getReviewRatingDetails } from 'services/reviews';

export const appendColorAndKeyToLabelObject = ({ LabelObject, primaryKey, colorMapper }) =>
  LabelObject.map((item) => {
    const color = getColorFromKey(colorMapper[item[primaryKey]]);
    const key = item[primaryKey];
    // eslint-disable-next-line no-param-reassign
    delete item[primaryKey];
    return {
      ...item,
      color,
      key,
    };
  });

const getData = async ({
  reviewId,
  employeeId,
  providerId,
  isIndividualReviewResult = false,
  responseId,
  providerType,
  isPreview,
  previewSubmissionStatus,
  previewProviderType,
}) => {
  try {
    const response = await getReviewRatingDetails({
      reviewId,
      employeeId,
      providerId,
      isIndividualReviewResult,
      responseId,
      providerType,
      isPreview,
      previewSubmissionStatus,
      previewProviderType,
    });
    let { providerTypes } = response;
    const providerKey = 'providerTypeKey';
    providerTypes = appendColorAndKeyToLabelObject({
      LabelObject: providerTypes,
      primaryKey: providerKey,
      colorMapper: VISIBLE_PROVIDER_TYPES_COLOR_MAPPING,
    });
    return {
      ...response,
      providerTypes,
    };
  } catch (error) {
    console.log('Error fetching rating data :', error);
  }
  return null;
};

export const useRatingResultData = ({
  reviewId,
  employeeId,
  providerId,
  isIndividualReviewResult = false,
  responseId,
  providerType,
}) => {
  const { isPreview, providerType: previewProviderType } = useReviewPreviewParams();
  const previewSubmissionStatus = useReviewPreviewPageStatus();

  return useQuery(
    [REACT_QUERY_KEYS.ReviewRatingResultData, reviewId, employeeId, providerId, responseId, isIndividualReviewResult],
    () =>
      getData({
        reviewId,
        employeeId,
        providerId,
        isIndividualReviewResult,
        responseId,
        providerType: providerType || previewProviderType,
        isPreview,
        previewSubmissionStatus,
        previewProviderType,
      })
  );
};
